import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const ControlTransportParameterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M5 18L5 13.5L2 13.5L2 18L5 18ZM9.5 18L9.5 11.5L6.5 11.5L6.5 18L9.5 18ZM13.5 18L13.5 9L11 9L11 18L13.5 18ZM18 18L18 7L15 7L15 18L18 18Z"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
      />
      <circle
        cx="3.500000"
        cy="9.500000"
        r="1.000000"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
      />
      <path
        d="M4 2.5C4 2.21 3.77 2 3.5 2C3.22 2 3 2.21 3 2.5L3 8.5L4 8.5L4 6L5 6C5.27 6 5.5 5.78 5.5 5.5C5.5 5.21 5.27 5 5 5L4 5L4 4L5 4C5.27 4 5.5 3.78 5.5 3.5C5.5 3.21 5.27 3 5 3L4 3L4 2.5Z"
        fill="currentColor"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
